(function () {
  var mobileFooterQuery = window.matchMedia('(max-width: 749px)');

  function syncFooterAccordions(footer) {
    footer.querySelectorAll('.gm-footer-v2__details').forEach(function (details) {
      if (mobileFooterQuery.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    });
  }

  function initFooter() {
    var help = document.querySelector('.gm-help');

    document.querySelectorAll('[data-gm-footer-v2]').forEach(function (footer) {
      syncFooterAccordions(footer);

      if (!help || !('IntersectionObserver' in window) || footer.dataset.gmFooterObserved === 'true') return;
      footer.dataset.gmFooterObserved = 'true';

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          help.classList.toggle('gm-help--footer-visible', entry.isIntersecting);
        });
      }, { threshold: 0.08 });
      observer.observe(footer);
    });

    if (!help) return;
    var trigger = help.querySelector('.gm-help__trigger');
    var label = trigger && trigger.textContent ? trigger.textContent.trim() : '';
    if (trigger && label && !trigger.hasAttribute('aria-label')) {
      trigger.setAttribute('aria-label', label);
    }
  }

  function syncAllFooterAccordions() {
    document.querySelectorAll('[data-gm-footer-v2]').forEach(syncFooterAccordions);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooter, { once: true });
  } else {
    initFooter();
  }

  if (typeof mobileFooterQuery.addEventListener === 'function') {
    mobileFooterQuery.addEventListener('change', syncAllFooterAccordions);
  } else if (typeof mobileFooterQuery.addListener === 'function') {
    mobileFooterQuery.addListener(syncAllFooterAccordions);
  }

  document.addEventListener('shopify:section:load', initFooter);
})();
